import * as utils from "@/utils.js";

export default {
    getInvestors: (state, getters, rootState) => {
        if (
            rootState.user.bpi !== null &&
            rootState.user.bpi.investors_profiles.length !== 0
        ) {
            const investorsProfiles = rootState.user.bpi.investors_profiles;
            const investors = investorsProfiles.map(investor => {
                return {
                    model: "investor",
                    key: utils.generateUID(),
                    object: {
                        ...investor
                    }
                };
            });
            return investors;
        }

        return [
            {
                model: "investor",
                key: utils.generateUID(),
                object: {
                    id: utils.generateUID(),
                    motivations: [],
                    firstName: "",
                    lastName: "",
                    sex: "",
                    birthday: "",
                    SituationFamiliale: null,
                    CIN: "",
                    address: "",
                    mobilite_reduite: false,
                    email: "",
                    phone: "",
                    niveauDeFormation: null,
                    niveauDeFormationAutre: "",
                    experiencePro: null,
                    experienceProAutre: "",
                    yearsOfExperience: null,
                    formationNeed: []
                }
            }
        ];
    }
};
